export default {
    load: true,
    error: false,
    errorText: '',

    article: [],
    video: [],
}